import moment from 'moment';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { CustomIntervalDialogComponent } from '../custom-interval-dialog/custom-interval-dialog.component';

import { MODAL_WIDTH } from '@app/utility/app.util';
import { DateIntervalsUsergroupStats } from '@sociuu/interfaces';

export type DateIntervalType = { [key in DateIntervalsUsergroupStats]: string };
export type DateType = 'Today' | 'Week' | 'Month' | 'Quarter' | 'Year' | 'Total';

export const DATE_INTERVAL_MAPPING: DateIntervalType = {
  [DateIntervalsUsergroupStats.TODAY]: 'Today',
  [DateIntervalsUsergroupStats.WEEK]: 'Week',
  [DateIntervalsUsergroupStats.MONTH]: 'Month',
  [DateIntervalsUsergroupStats.QUARTER]: 'Quarter',
  [DateIntervalsUsergroupStats.YEAR]: 'Year',
  [DateIntervalsUsergroupStats.TOTAL]: 'Total',
};

@Component({
  selector: 'custom-date-select-wrapper',
  templateUrl: './custom-date-select-wrapper.component.html',
  styleUrls: ['./custom-date-select-wrapper.component.scss']
})
export class CustomDateSelectWrapperComponent implements OnInit, OnChanges {
  @Input() public height: number = 40;
  @Input() public defaultDate: DateType = null;
  @Input() public isTodayDateEnabled: boolean = true;
  @Input() public isCustomDateEnabled: boolean = true;
  @Output() private customDateHandler: EventEmitter<any> = new EventEmitter();
  @Output() private selectedDateHandler: EventEmitter<string> = new EventEmitter();

  public selectedDate: string  = null;
  public customDateRange: { from: string, to: string } = undefined;
  public dateIntervalText: DateIntervalType = DATE_INTERVAL_MAPPING;
  public dateInterval: typeof DateIntervalsUsergroupStats = DateIntervalsUsergroupStats;

  constructor(private dialog: MatDialog) { }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultDate?.currentValue) {
      this.customDateRange = null;
      this.selectedDate = this.defaultDate;
    }
  }

  public ngOnInit(): void {}

  public openIntervalDialog(): void {
    const dialogRef = this.dialog.open(CustomIntervalDialogComponent, {
      width: MODAL_WIDTH.MD,
    });

    dialogRef.afterClosed().subscribe((response: any): void => {
      if (!response.dateFrom || !response.dateTo) return;
      this.selectedDate = null;
      this.customDateRange = {
        from: moment(response.dateFrom).format('YYYY/MM/DD'),
        to: moment(response.dateTo).format('YYYY/MM/DD'),
      };
      this.customDateHandler.emit(this.customDateRange);
    });
  }

  public setDate(interval: string): void {
    this.customDateRange = null;
    this.selectedDate = this.dateIntervalText[interval];
    this.selectedDateHandler.emit(interval);
  }

  public clear(): void {
    this.customDateRange = null;
    this.selectedDate = this.defaultDate || null;
  }

}
